export default __webpack_public_path__ + "static/media/bachelors-undergrad-psychdegree-diploma.993c608e.pdf";